<ng-container>
  <div
      class="drag-drop-component"
      [ngClass]="fullFramePadding ? 'full-padding' : ''"
      [appLoadingAnimation]="uploadingFileInProgress"
      [attr.data-test]="'drag-drop-file-component'">
    <h6>{{ uploadHeaderText | translate }}</h6>
    <div class="drag-drop-files-wrapper">
      <div
          class="file-upload-container"
          [style.width]="files && files.length > 0 ? '30%' : '100%'"
          appDragDropFileUpload
          [disabled]="!!(files && files.length >= supportedMaxAmountOfFiles)"
          (fileDropped)="handleDragDropFiles($any($event))"
          [appLoadingAnimation]="uploadingFileInProgress"
          [attr.data-test]="'desc-dragDropFileContainer'">
        <div class="file-upload-text-wrapper">
          <span class="icon-upload" [attr.data-test]="'drag-drop-file-icon'"></span>
          <div class="file-upload-text" [class.hide-when-files-uploaded]="files && files.length > 0">
              <span [attr.data-test]="'drag-drop-file-title'">
                <b> {{ 'drag-drop.upload-title' | translate }} </b>
              </span>
            <span
                [attr.data-test]="'drag-drop-file-desc'"> {{ 'drag-drop.upload-desc' | translate: {filesFormat: supportedFileFormates?.join(", ")} }}</span>
          </div>
        </div>
      </div>
      @if (files && files.length > 0) {
        <div class="files-added" [appLoadingAnimation]="uploadingFileInProgress" [attr.data-test]="'file-uploaded'">
          @for (file of files; track file.file.name) {
            <div class="added-file-name">
              <span [attr.data-test]="'title-uploadedFileName'">• {{ file.file.name }} </span>
              @if (file.uploadingInProgress) {
                <span class="uploaded-file-status loading-animation" [attr.data-test]="'uploading-spinner'"></span>
              } @else if (file.uploadSuccess) {
                <span class="uploaded-file-status icon-checkmark" [attr.data-test]="'upload-success-checkmark'"></span>
              } @else {
                <span
                    class="delete-file"
                    (click)="deleteUploadedFiles(file)"
                    [attr.data-test]="'delete-uploaded-file'"> <b>x</b>
                </span>
              }
            </div>
          }
        </div>
      }
    </div>
    <div class="error-message-container"
         [attr.data-test]="'invalid-csv-file-container'">
      @if (notSupportedFilesFormatError) {
        <div class="message-wrapper">
          <span class="icon-close icon-close__circle"
                [attr.data-test]="'invalid-csv-file-circle'"></span>
          <span class="message-text"
                [attr.data-test]="'invalid-csv-file-text'">{{ 'drag-drop.invalid-format' | translate }}</span>
        </div>
      }
      @if (maxAmountOfFilesExceededError) {
        <div class="message-wrapper">
          <span class="icon-close icon-close__circle"
                [attr.data-test]="'error-message-circle'"></span>
          <span class="message-text"
                [attr.data-test]="'error-message-text'">{{ 'drag-drop.max-files-exceeded' | translate:{maxFiles: supportedMaxAmountOfFiles} }}</span>
        </div>
      }
      @if (maxFileSizeExceededError) {
        <div class="message-wrapper">
          <span class="icon-close icon-close__circle"
                [attr.data-test]="'error-message-circle'"></span>
          <span class="message-text"
                [attr.data-test]="'error-message-text'">{{ 'drag-drop.max-file-size-exceeded' | translate:{maxSize: maxFileSizeInMB} }}</span>
        </div>
      }
      @if (maxAllFilesSizeExceededError) {
        <div class="message-wrapper">
          <span class="icon-close icon-close__circle"
                [attr.data-test]="'error-message-circle'"></span>
          <span class="message-text"
                [attr.data-test]="'error-message-text'">{{ 'drag-drop.max-total-size-exceeded' | translate:{maxTotalSize: maxAllowedFileSizeInMB} }}</span>
        </div>
      }
      @if (duplicateFilesError) {
        <div class="message-wrapper">
          <span class="icon-warning icon-warning__circle"
                [attr.data-test]="'warning-message-circle'"></span>
          <span class="message-text"
                [attr.data-test]="'warning-message-text'">{{ 'drag-drop.duplicate-files-warning' | translate:{fileNames: duplicateFilesError} }}</span>
        </div>
      }
    </div>
    <div class="file-upload-buttons-container">
      @if (showDownloadCsvTemplateButton) {
        <button
            class="button button--link"
            (click)="createCsv('quick-order-template')"
            [attr.data-test]="'button-downloadCartItemsCsv'">
          <span class="icon-download" [attr.data-test]="'button-download-csv-template-icon'"></span>
          <span class="text download-csv" [attr.data-test]="'button-download-csv-template-text'">
            {{ 'drag-drop.download' | translate }}
          </span>
        </button>
      }
      @if (showUploadButton) {
        <button
            [disabled]="!files || disabledAddButton"
            class="button upload-csv"
            (click)="uploadFiles()"
            [attr.data-test]="'button-uploadCartItemsCsv'">
          {{ 'drag-drop.upload' | translate }}
        </button>
      }
    </div>
  </div>
</ng-container>
